import {
  Building2, ShieldCheck, AlertTriangle, ClipboardList, ClipboardCheck, FileCheck2,
} from "lucide-react";

/* ══════════════════════════════════════════════════════════════════════
   GRC MANAGER — GROUP LEVEL OVERVIEW (mock data)
   Wire to real group-level endpoints in a later step.
   ══════════════════════════════════════════════════════════════════════ */

/* Catalog/framework the compliance score is measured against */
export const COMPLIANCE_CATALOG = "IM8";

/* ── Types ──────────────────────────────────────────────────────────── */
export interface GroupKpiItem {
  id: string;
  label: string;
  value: number | string;
  delta: string;            // e.g. "+2 vs last quarter"
  deltaDir: "up" | "down";
  icon: React.ElementType;
  color: string;
  borderColor: string;
  catalog?: string;         // shown as a small badge (e.g. compliance catalog)
}

export interface OrgPerformanceRow {
  id: string;               // org id — used for drill-down
  name: string;
  applications: number;     // GRC summary → totalApplications
  ssps: number;             // GRC summary → activePublishedSsps
  activeAssessments: number;// assessment-pipeline → totalAssessments
  openFindings: number;     // GRC summary → openFindingsCount
  complianceScore: number;  // GRC summary → overallComplianceScore (0-100)
}

export interface DonutSlice {
  label: string;
  value: number;            // raw count
  pct: number;              // percentage of total
  color: string;
}

/* ── KPI cards ──────────────────────────────────────────────────────── */
export const GROUP_KPIS: GroupKpiItem[] = [
  {
    id: "total_orgs",
    label: "Total Organizations",
    value: 12,
    delta: "2 vs last quarter",
    deltaDir: "up",
    icon: Building2,
    color: "#8b5cf6", // chart-1 — app primary violet
    borderColor: "border-border",
  },
  {
    id: "active_ssps",
    label: "Active SSPs",
    value: 0,
    delta: "",
    deltaDir: "up",
    icon: FileCheck2,
    color: "#a78bfa", // violet — matches the Active SSPs accent in config
    borderColor: "border-border",
  },
  {
    id: "group_compliance",
    label: "Group Compliance Score",
    value: "84%",
    delta: "4% vs last quarter",
    deltaDir: "up",
    icon: ShieldCheck,
    color: "#10b981", // chart-3 — green
    borderColor: "border-border",
    catalog: COMPLIANCE_CATALOG,
  },
  {
    id: "high_risk_orgs",
    label: "High Risk Applications",
    value: 3,
    delta: "1 vs last quarter",
    deltaDir: "down",
    icon: AlertTriangle,
    color: "#ef4444", // chart-5 — red
    borderColor: "border-border",
  },
  {
    id: "open_findings",
    label: "Open Findings",
    value: 625,
    delta: "82 vs last quarter",
    deltaDir: "up",
    icon: ClipboardList,
    color: "#f59e0b", // chart-4 — amber
    borderColor: "border-border",
  },
  {
    id: "active_assessments",
    label: "Approved Assessments",
    value: 11,
    delta: "2 vs last quarter",
    deltaDir: "up",
    icon: ClipboardCheck,
    color: "#06b6d4", // chart-2 — cyan
    borderColor: "border-border",
  },
];

